import { ShowBase, useShowContext } from "ra-core";
import { InvoiceDetail } from "./InvoiceDetail";

function Content() {
  const { record, isPending } = useShowContext<any>();
  if (isPending || !record) return null;
  return <InvoiceDetail invoiceId={record.id} />;
}

export function InvoiceShow() {
  return (
    <ShowBase>
      <Content />
    </ShowBase>
  );
}
